import { create } from "zustand";

/**
 * Закачки вложений, которые воркер не скачал сразу (крупные): от клика
 * оператора до события media.downloaded. Прогресс приходит событиями
 * media.progress — без него «Скачать» на видео в пару сотен МБ выглядело бы
 * зависшим.
 */
export interface MediaDownload {
  status: "queued" | "downloading" | "failed";
  received: number;
  total: number;
  error: string | null;
}

interface MediaDownloadsState {
  items: Record<string, MediaDownload>;
  start: (mediaId: string) => void;
  progress: (mediaId: string, received: number, total: number) => void;
  fail: (mediaId: string, error: string) => void;
  done: (mediaId: string) => void;
}

export const useMediaDownloads = create<MediaDownloadsState>((set) => ({
  items: {},
  start: (mediaId) =>
    set((s) => ({
      items: { ...s.items, [mediaId]: { status: "queued", received: 0, total: 0, error: null } },
    })),
  progress: (mediaId, received, total) =>
    set((s) => ({
      items: { ...s.items, [mediaId]: { status: "downloading", received, total, error: null } },
    })),
  fail: (mediaId, error) =>
    set((s) => ({
      items: {
        ...s.items,
        [mediaId]: { ...(s.items[mediaId] ?? { received: 0, total: 0 }), status: "failed", error },
      },
    })),
  done: (mediaId) =>
    set((s) => {
      const { [mediaId]: _, ...rest } = s.items;
      return { items: rest };
    }),
}));
